module.exports = __webpack_public_path__ + "img/morning_icon.f145f0d5.png";